module.exports = __webpack_public_path__ + "static/media/chalsea.0160c8c8.jpg";